import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { RenderElement } from "./RenderElement";
export class SkinRenderElement extends RenderElement {
    setSkinData(value) {
        this._renderElementOBJ.skinnedData = value;
    }
    constructor() {
        super();
    }
    _createRenderElementOBJ() {
        this._renderElementOBJ = Laya3DRender.Render3DPassFactory.createSkinRenderElement();
    }
    _render(context) {
    }
}
